/**
 * .select-other-array
 * Register a trigger for the .select-other-array -> to make the field required if certain value matches
 *
 * Add attribute with a list of values to a field
 *          'data-select-other-array' => "MD,DO",
 *  and reference another item(s) that will be made required if data-other-array matches selection  value
 *       'data-required-select-if-other-array' => "#npi",
 *  In this example above, if the value of a field with 'data-other-array' attribute matches MD, an #npi field will be made required
 *
 * @package:  Betta
 * @version:  2.1
 * @author:   Cyrill N KALITA
 */


;(function($) {

    "use strict";

    $(function(){

        var $selector = '[data-select-other-array]';

        /**
         * Define the method
         *
         * @return string
         */
        var selectOtherArray = function(){
            // Trigger Input Field
            var field = $(this);
            // Extract info from data-* attributes
            // container is the block that needs to become visible
            var container = $(field).data('select-other-array');
            // no container, return
            if(!container){
                return;
            }
            // Field that needs to be required
            var requiredFiled = $(field).data('required-if-select-other-array');
            // Comparison value
            var selectedText = $(this).find("option:selected").text();
            // Toggle Requirement
            if($.inArray(selectedText, container.split(',').map(function(item){return item.trim();})) !== -1){
                $(requiredFiled).attr('required', 'required');
            } else {
                $(requiredFiled).removeAttr('required');
            }
        }

        /**
         * Append method to any input with class .input-trim
         */
        $($selector).change(selectOtherArray);

        /**
         * Append method to any remotely loaded modal
         */
        $('#remote').on('loaded.bs.modal', function (e) {
            // Identify the Modal
            var modal  = $(this);
            // Attach the change action
            modal.find($selector).change(selectOtherArray);
        });
    });

})(window.jQuery);
